import React, { useState } from 'react';
import './AllowanceOperations.css';
import MoneyInput from '../components/MoneyInput/MoneyInput';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { PayWeeklyAllowance } from '../../utils/FamilyApiService';
import CameraAuthentication from '../components/CameraAuthentication/CameraAuthentication';
import Modal from 'react-modal';

const customStylesModal = {
    content: {
        top: '300px',
        width: '435px',
        height: '335px',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        border: 'solid black 1px',
    },
    overlay: {
        transition: 'all 0.3s linear',
        backgroundColor: 'rgba(150, 150, 150, 0.8)'
    },
};

const AllowanceOperations = ({ refreshTrigger }) => {

    const [loading, setLoading] = useState(false);
    const [transferSuccess, setTransferSuccess] = useState(null);
    const [transferResultMessage, setTransferResultMessage] = useState("");

    async function submitPayWeeklyAllowance() {
        setTransferResultMessage("");
        setLoading(true);
        try {
            var result = await PayWeeklyAllowance(null);
            setTransferSuccess(result.success);
            setTransferResultMessage(result.transferResultMessage);
            refreshTrigger();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }




        // confirmAlert({
        //     customUI: ({ onClose }) => {
        //         return (
        //             <div className='cameraAuthenticationModal'>
        //                 <CameraAuthentication onCompleteCountdown={async (param) => {
        //                     setTransferResultMessage("");
        //                     setLoading(true);
        //                     onClose();
        //                     var result = await PayWeeklyAllowance(param);
        //                     setLoading(false);
        //                     setTransferSuccess(result.success);
        //                     setTransferResultMessage(result.transferResultMessage);
        //                     refreshTrigger();
        //                 }} />
        //             </div>
        //         );
        //     }
        // });
    };

    return (
        <div className="allowanceContainer">
            <Modal
                isOpen={loading}
                style={customStylesModal}
            >
                <img src="/images/fingerprint.gif" />
            </Modal>
            <div>
                <div className="allowanceHeader"><span className="kvalstadBankLogo"><i className="fas fa-piggy-bank"></i></span>Kvalstad banken</div>
                <div className="moneyInputParentContainer">
                    <div><MoneyInput kidName="Sivert" refreshTrigger={refreshTrigger} /></div>
                    <div><MoneyInput kidName="Jenny" refreshTrigger={refreshTrigger} /></div>
                </div>
            </div>
            <div className="weeklyAllowanceContainer">
                <button className="transferButton buttonUOutline weeklyAllowanceButton" disabled={loading} onClick={async () => submitPayWeeklyAllowance()}><div className="buttonSpinner" style={{ display: loading ? 'block' : 'none' }}></div><div style={{ display: loading ? 'none' : 'block' }}>Overfør ukepenger<span className="pig"><i className="fas fa-piggy-bank"></i></span></div></button>
                <div className={transferSuccess ? "transferSuccess" : "transferFail"}>{transferResultMessage}</div>
            </div>
        </div>
    );
};

export default AllowanceOperations;